// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_9e1425b4d3--wrapper--NC3dg","more-link":"_9e1425b4d3--more-link--l3M8K"};